(function(Drupal) {

  Drupal.behaviors.linkBlock = {
    attach(context) {
      console.log('@todo Replace me with the real JS behavior.');
    },
  };

})(Drupal);
